/* This is the Climate Change component N.6 */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 43px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 400px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សម្ភារបរិក្ខារ
            </td>
            <td class="row-data">ចំនួនសម្ភារបរិក្ខារសរុប</td>
            <td class="row-data">ចំនួនបន្ទប់រៀនដែលមាន</td>
          </tr>
          <tr v-for="(value, row) in fan_con.length" :key="row">
            <td
              style="
                width: 400px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ fan_con[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].d.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].d[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { fan_con } from "@/utils/ascf/climateVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      fan_con: fan_con,
    };
  },
};
</script>
<style scoped>
.number {
  width: 200px;
  text-align: center;
}
.row-data {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>